// Google Analytics 4 + Google Ads conversion tracking — configuration points.
// Set these in /app/frontend/.env and the trackers activate automatically:
//   REACT_APP_GA4_MEASUREMENT_ID          GA4 Measurement ID (G-XXXXXXXXXX)
//   REACT_APP_GOOGLE_ADS_CONVERSION_ID    Google Ads Conversion ID (AW-XXXXXXXXXX)
//   REACT_APP_GOOGLE_ADS_CONVERSION_LABEL Google Ads Conversion Label
// Until IDs are provided, every trackEvent call is a safe no-op.
const GA4_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const ADS_CONVERSION_ID = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_ID;
const ADS_CONVERSION_LABEL = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL;

let initialised = false;

export const initAnalytics = () => {
    if (initialised || (!GA4_MEASUREMENT_ID && !ADS_CONVERSION_ID)) return;
    initialised = true;
    const tagId = GA4_MEASUREMENT_ID || ADS_CONVERSION_ID;
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    if (GA4_MEASUREMENT_ID) window.gtag("config", GA4_MEASUREMENT_ID);
    if (ADS_CONVERSION_ID) window.gtag("config", ADS_CONVERSION_ID);
};

export const trackEvent = (name, params = {}) => {
    if (typeof window.gtag === "function") window.gtag("event", name, params);
};

export const trackCTAClick = (location) =>
    trackEvent("growth_review_cta_click", { cta_location: location });

export const trackFormStart = () => trackEvent("growth_review_form_start");

export const trackFormSuccess = () => {
    trackEvent("growth_review_form_submit_success");
    if (ADS_CONVERSION_ID && ADS_CONVERSION_LABEL) {
        trackEvent("conversion", {
            send_to: `${ADS_CONVERSION_ID}/${ADS_CONVERSION_LABEL}`,
        });
    }
};
